
import { initUpcomingEventsCalendars } from "./../js/upcomingEventsCalendars/initUpcomingEventsCalendars";

initUpcomingEventsCalendars("upcoming-events-calendar");
